import { getUrlParam } from "./url";

const regs = {
    android: /Android|Adr/i,
    ios: /iPhone|iPad|iPod/i,
    wx: /MicroMessenger/i,
    app: /dangdang/i,
    mobile: /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|mobi/i,
    lang: /Accept-Language\/([^;\s]+)/i
};
// app/h5/wx | android/ios/pc | 是否iPhone X
export function ua() {
    if (!ua.inited) {
        const _ua = window.navigator.userAgent.toLocaleLowerCase();
        const isMobile = navigator.userAgentData ?
            navigator.userAgentData.mobile : regs.mobile.test(_ua);
        const isWeixin = regs.wx.test(_ua) ? 'wx' : false;
        const appOrH5 = regs.app.test(_ua) ? 'app' : 'h5';
        let androidOrIos;
        if (regs.android.test(_ua)) {
            androidOrIos = 'android';
        } else if (regs.ios.test(_ua)) {
            androidOrIos = 'ios';
        } else {
            androidOrIos = 'pc';
        }
        // const androidOrIos = ['Android', 'Adr'].some(str =>
        //     _ua.indexOf(str) > -1) ? 'android' : 'ios';
        const screenCondition = [[375, 812], [414, 896], [276]];
        const iphonex = screenCondition.some(([w, h]) =>
            (h !== undefined || h === window.screen.height) && w === window.screen.width)
            ? 'iphonex' : 'normal';
        const skinModel = _ua.match(/skinModel\/([\d\.]+)/i) ? Number(_ua.match(/skinModel\/([\d\.]+)/i)[1]) : 0;
        const langMatch = _ua.match(regs.lang);
        let lang = langMatch && langMatch[1] && langMatch[1].trim() ||
            // navigator.language || navigator.userLanguage ||
            'zh-CN';
        if (lang.toLowerCase() === 'zh-cn') {
            lang = 'zh-CN';
        } else {
            lang = 'en-US';
        }
        ua.instance = [isWeixin || appOrH5, androidOrIos, skinModel, iphonex, isMobile, lang];
        ua.inited = true;
    }
    return ua.instance;
}

export function getSkinModel() {
    console.log('getSkinModel-inited', window.navigator.userAgent)
    if (!getSkinModel.inited) {
        const _ua = window.navigator.userAgent;
        const skinModel = _ua.match(/skinModel\/([\d\.]+)/i) ? _ua.match(/skinModel\/([\d\.]+)/i)[1] : 0;
        getSkinModel.skinModel = Number(skinModel);
        getSkinModel.inited = true;
    }
    console.log('getSkinModel', getSkinModel.skinModel)
    return getSkinModel.skinModel;
}

export function getVersion() {
    if (!getVersion.version) {
        const _ua = window.navigator.userAgent;
        const version = _ua.match(/dangdang\/([\d\.]+)/i) ? _ua.match(/dangdang\/([\d\.]+)/i)[1] : 0;
        getVersion.version = version;
        getVersion.inited = true;
    }
    console.log('getVersion', getVersion.version)
    return getVersion.version;
}

function getAppVersion() {
    const { appVersion, platform } = getUrlParam();
    if (appVersion) {
        return { appVersion, platform };
    }
    return false;
}
function formattingAppVersion(version) {
    return version.split('.').map(str => str.padStart(4, '0')).join('');
}
export function appVersionStatus(androidVersion, iosVersion, currentVersion) {
    const appVersionData = currentVersion ? currentVersion : getAppVersion();
    if (!appVersionData) {
        return false;
    }
    const { appVersion, platform } = appVersionData;
    const targetV = formattingAppVersion(platform === 'android' ? androidVersion : iosVersion);
    const urlVersion = formattingAppVersion(appVersion);
    return targetV == urlVersion || targetV < urlVersion;
}


// WEBPACK FOOTER //
// ./src/utils/ua.js